import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function RefreshIcon(props: any) {
    return (
        <Svg
            width={props?.size ? props.size : 14}
            height={props?.size ? props.size : 14}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <G
                clipPath="url(#clip0_1365_839)"
                stroke={props.color ? props.color : "#1434CB"}
                strokeWidth={0.875}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <Path d="M10.063 5.688h2.624V3.063" />
                <Path d="M10.303 10.5a4.812 4.812 0 11.1-6.903l2.284 2.09" />
            </G>
            <Defs>
                <ClipPath id="clip0_1365_839">
                    <Path fill="#fff" d="M0 0H14V14H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default RefreshIcon
